import { render, staticRenderFns } from "./EcocarotidiEditComponent.vue?vue&type=template&id=5960fa34&scoped=true"
import script from "./EcocarotidiEditComponent.vue?vue&type=script&lang=js"
export * from "./EcocarotidiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EcocarotidiEditComponent.vue?vue&type=style&index=0&id=5960fa34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960fa34",
  null
  
)

export default component.exports